// extracted by mini-css-extract-plugin
export default {"container":"squadSettings_container__5INgT","linksWrapper":"squadSettings_linksWrapper__SwXNl","linkWrapper":"squadSettings_linkWrapper__7oKMR"};